export default __webpack_public_path__ + "images/3c1cf623ec72b2b6cc4e0e4b17682d02.svg";